import { useContext } from 'react';
import { ToastContext } from './ToastContext';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Toast/useToast');
export var useToast = function useToast() {
  var _useContext = useContext(ToastContext),
      showToast = _useContext.showToast,
      hideToast = _useContext.hideToast;

  return {
    showToast: showToast,
    hideToast: hideToast
  };
};